import { render, staticRenderFns } from "./ReferenceFieldForm.vue?vue&type=template&id=2e35532e"
import script from "./ReferenceFieldForm.vue?vue&type=script&lang=js"
export * from "./ReferenceFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e35532e')) {
      api.createRecord('2e35532e', component.options)
    } else {
      api.reload('2e35532e', component.options)
    }
    module.hot.accept("./ReferenceFieldForm.vue?vue&type=template&id=2e35532e", function () {
      api.rerender('2e35532e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferenceFields/ReferenceFieldForm.vue"
export default component.exports